/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CartonGradeCatalogDTO, ErrorResponse } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class CartonGradeApi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Find a specific product variety based on the code
   *
   * @tags carton-grade-api
   * @name GetCartonGradeByCode
   * @summary Find product variety by code
   * @request GET:/api/carton-grades/{id}
   * @secure
   */
  getCartonGradeByCode = (id: number, params: RequestParams = {}) =>
    this.request<CartonGradeCatalogDTO, ErrorResponse | CartonGradeCatalogDTO>({
      path: `/api/carton-grades/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Fetch all codes from the product_variety table
   *
   * @tags carton-grade-api
   * @name GetCartonGrades
   * @summary Get all product variety codes
   * @request GET:/api/carton-grades
   * @secure
   */
  getCartonGrades = (params: RequestParams = {}) =>
    this.request<CartonGradeCatalogDTO[], ErrorResponse>({
      path: `/api/carton-grades`,
      method: "GET",
      secure: true,
      ...params,
    });
}
